import {
  RESET_ACCOUNT_STATUS
} from '../../constants/actions';

export function resetAccountStatus () {
  return dispatch => dispatch({ type: RESET_ACCOUNT_STATUS });
}



// WEBPACK FOOTER //
// ./src/store/actions/resetAccountStatus.js